var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconmetroLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.228,
    height: 40.366,
    viewBox: "0 0 25.228 40.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-location",
    "data-name": "Icon metro-location",
    d: "M20.969,1.928A12.614,12.614,0,0,0,8.355,14.542c0,12.614,12.614,27.751,12.614,27.751S33.583,27.156,33.583,14.542A12.614,12.614,0,0,0,20.969,1.928Zm0,20.34A7.726,7.726,0,1,1,28.7,14.542,7.726,7.726,0,0,1,20.969,22.268Zm-4.888-7.726a4.888,4.888,0,1,1,4.888,4.888A4.888,4.888,0,0,1,16.081,14.542Z",
    transform: "translate(-8.355 -1.928)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmetroLocation);
export default __webpack_public_path__ + "static/media/Icon metro-location.537cc3c07e3aadbcd65df64f66367d05.svg";
export { ForwardRef as ReactComponent };